// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NChpr","delete":"styles_delete__1vnBF","update":"styles_update__1fd-G","add":"styles_add__15GJQ"};